import { AnalyticsItem } from '../../models/analytics/analytics_item';
import { AnalyticsItems } from '../../models/analytics/analytics_items';
import { ItemKey } from '../../models/item_key';
import { SupplierId } from '../../models/supplier_id';
import { TypedEvent } from '../../typed_event';

const DATA_SUBSTITUTE_CATALOG_ITEM_CODE = 'data-substitute-catalog-item-code';
const DATA_SUBSTITUTE_SUPPLIER_ID = 'data-substitute-supplier-id';
const DATA_CATALOG_ITEM_CODE = 'data-catalog-item-code';
const DATA_SUPPLIER_ID = 'data-supplier-id';

const VIEW = {
  variation: {
    linkName: 'DispReplacementAreaByVariation',
    name: 'バリエーション'
  },
  keyword: {
    linkName: 'DispReplacementAreaBySearch',
    name: 'キーワード検索結果'
  },
  category: {
    linkName: 'DispReplacementAreaByCategory',
    name: 'カテゴリ検索'
  }
};

const ViewTypeKey = {
  VARIATION: 'variation',
  KEYWORD: 'keyword',
  CATEGORY: 'category'
} as const;

export type ViewType = typeof ViewTypeKey[keyof typeof ViewTypeKey];

export class SubstituteItemAreaAction {
  static readonly SEND_SUBSTITUTE_ITEM_AREA_EVENT = new TypedEvent<AnalyticsItems>();

  /// 代替品エリア
  static setAnalyticsItems(viewType: ViewType, parentSelector: string, targetSelector: string) {
    /// 代替品がある商品の場合はAnalyticsの送信をする
    const target = new Array<HTMLElement>();
    const analyticsItems = Array.prototype.slice
      .call(document.querySelectorAll(parentSelector))
      .filter(
        (element) =>
          element.querySelector(`[${DATA_CATALOG_ITEM_CODE}]`) != null &&
          element.querySelector(`[${DATA_SUPPLIER_ID}]`) != null &&
          element.querySelector(`[${DATA_SUBSTITUTE_CATALOG_ITEM_CODE}]`) != null &&
          element.querySelector(`[${DATA_SUBSTITUTE_SUPPLIER_ID}]`) != null
      )
      .map((element) => {
        const item = element.querySelector(`[${DATA_CATALOG_ITEM_CODE}]`);
        const catalogItemCode = item.getAttribute(DATA_CATALOG_ITEM_CODE);
        const supplierId = new SupplierId(item.getAttribute(DATA_SUPPLIER_ID));

        target.push(element.querySelector(targetSelector));

        return Array.prototype.map.call(
          /// 念のため、取得対象のモジュールに含まれるdata属性の値を取得する
          element.querySelectorAll(`[${DATA_SUBSTITUTE_CATALOG_ITEM_CODE}]`),
          (substituteItem) => {
            const analyticsItem = new AnalyticsItem();
            analyticsItem._viewAreaName = `${VIEW[viewType].name}_商品情報`;
            analyticsItem._catalogItemCode = catalogItemCode;
            analyticsItem._supplierId = supplierId;
            analyticsItem._substituteItemKey = new ItemKey(
              new SupplierId(substituteItem.getAttribute(DATA_SUBSTITUTE_SUPPLIER_ID)),
              substituteItem.getAttribute(DATA_SUBSTITUTE_CATALOG_ITEM_CODE)
            );

            return analyticsItem;
          }
        );
      })
      .flat();

    if (analyticsItems.length) {
      this.SEND_SUBSTITUTE_ITEM_AREA_EVENT.trigger({
        target: target[0], /// 代替品の先頭のみ取得
        linkName: VIEW[viewType].linkName,
        analyticsData: {
          items: analyticsItems
        }
      });
    }
  }
}
